<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <h2 *ngIf="!btnImport">Importación Datos de Personal
            <configTools 
                [rowsExport]="rowsExport"
                [Title]="tituloTabla"
                [bNew]="false"
                [bImportExport]="bImport"
                (ImportChange)="import($event)">
            </configTools>            
        </h2>
        <h2 *ngIf="btnImport">Importación Datos de Personal
            <configTools 
                [rowsExport]="rowsExport"
                [Title]="tituloTabla"
                [bNew]="false"
                (ImportChange)="import($event)">
            </configTools>            
        </h2>
    </div>
</div>

<div class="ibox">
    <div class="ibox-content">
        <mat-error *ngIf="Invalido" class="Invalido">{{MensajeError}}</mat-error>
        <div class="row">
            <div class="col-lg-12">
                <p-dropdown [options]="dropdownOptions" [(ngModel)]="selectedValue" optionLabel="descripcion" [filter]="true" 
                    filterBy="descripcion" [showClear]="true" placeholder="Seleccione una Opción"
                    (ngModelChange)="onChangeOpcion($event)">
                </p-dropdown>
            </div>
        </div>
    
        <div *ngIf="showDetails" class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="header">
                    <div class="table table-striped">
                        <p-table #dt [value]="registros" [rows]="10" [paginator]="true" responsive="true"
                                [rowHover]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Registros" [showCurrentPageReport]="true">
                            
                            <ng-template pTemplate="header">
                                <tr>
                                    <th *ngFor="let column of columns; let i = index;" pSortableColumn="{{column}}" [ngStyle]="getCellStyle(column)">
                                        {{column}}<p-sortIcon field="{{column}}"></p-sortIcon>
                                    </th>
                                    <th style="width: 200px" pSortableColumn="message">errores <p-sortIcon field="message"></p-sortIcon></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-registro>
                                <tr>
                                    <td *ngFor="let column of columns" [field]="column" [ngStyle]="getCellStyle(column)">
                                        <!-- Aplicar estilo y formato de fecha a las columnas de fecha -->
                                        <ng-container *ngIf="isDateColumn(column)">
                                            <span>{{ registro[column] | date:'dd/MM/yyyy' }}</span>
                                        </ng-container>
                                        <!-- Si no es una columna de fecha, muestra el contenido normalmente -->
                                        <ng-container *ngIf="!isDateColumn(column)">
                                            {{ registro[column] }}
                                        </ng-container>
                                    </td>
                                    <td style="width: 200px">
                                        <ng-template ngFor let-error [ngForOf]="registro.errores">
                                          <!-- Cada error en una fila separada -->
                                          <div>{{error}}</div>
                                        </ng-template>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="buttons">
            <button *ngIf="showDetails" class="btn btn-secondary" type="submit" (click)="onClearOpcion(true)">Cancelar</button>
            <!-- <button *ngIf="showDetails" class="btn btn-primary" type="submit" (click)="confirmar()" [disabled]="!habilita">Importar Correctos</button> -->
            <button *ngIf="showDetails" class="btn btn-primary" type="submit" (click)="confirmar()" [disabled]="!habilitaTodo">Importar</button>
        </div>  
          
    </div>  
</div>
  